import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
} from "redux/helpers/fetching"
import { fetchTawk } from "redux/features/tawk/tawkThunk"

const tawkAdapter = createEntityAdapter()
export const initialState = tawkAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const tawkSlice = createSlice({
  name: "tawk",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchTawk.pending, (state) => handleFetchPending(state))
      .addCase(fetchTawk.rejected, (state) => handleFetchRejected(state))
      .addCase(fetchTawk.fulfilled, (state, { payload }) => {
        tawkAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
  },
})

export const { selectById: selectTawkById } = tawkAdapter.getSelectors(
  (state: RootState) => state.features.tawk,
)
export const selectFetchStatus = (state: RootState) =>
  state.features.tawk.fetchStatus

export default tawkSlice.reducer
